import {
  SALES_ORDER_LIST,
  SALES_ORDER_LIST_SUCCESS,
  SALES_ORDER_LIST_FAILURE,
  SALES_ORDER_DATA,
  SALES_ORDER_DATA_SUCCESS,
  SALES_ORDER_DATA_FAILURE,
  SALES_ORDER_SEARCH,
  SALES_ORDER_SEARCH_SUCCESS,
  SALES_ORDER_SEARCH_FAILURE,
  SALES_ORDER_CREATE,
  SALES_ORDER_CREATE_SUCCESS,
  SALES_ORDER_CREATE_FAILURE,
  SALES_ORDER_UPDATE,
  SALES_ORDER_UPDATE_SUCCESS,
  SALES_ORDER_UPDATE_FAILURE,
  SALES_ORDER_VOID,
  SALES_ORDER_VOID_SUCCESS,
  SALES_ORDER_VOID_FAILURE,
  SALES_ORDER_PDF,
  SALES_ORDER_PDF_SUCCESS,
  SALES_ORDER_PDF_FAILURE,
  SALES_ORDER_EMAIL_AUTOMATED,
  SALES_ORDER_EMAIL_AUTOMATED_SUCCESS,
  SALES_ORDER_EMAIL_AUTOMATED_FAILURE,
  SALES_ORDER_EMAIL_RESEND_AUTOMATED,
  SALES_ORDER_EMAIL_RESEND_AUTOMATED_SUCCESS,
  SALES_ORDER_EMAIL_RESEND_AUTOMATED_FAILURE,
  SALES_ORDER_DAILY_BALANCE,
  SALES_ORDER_DAILY_BALANCE_SUCCESS,
  SALES_ORDER_DAILY_BALANCE_FAILURE,
  SALES_ORDER_ITEM_SEARCH,
  SALES_ORDER_ITEM_SEARCH_SUCCESS,
  SALES_ORDER_ITEM_SEARCH_FAILURE,
  SALES_ORDER_ITEM_LIST,
  SALES_ORDER_ITEM_LIST_SUCCESS,
  SALES_ORDER_ITEM_LIST_FAILURE,
  SALES_ORDER_STATUS_LIST,
  SALES_ORDER_STATUS_LIST_SUCCESS,
  SALES_ORDER_STATUS_LIST_FAILURE,
  SALES_ORDER_STATUS_DATA,
  SALES_ORDER_STATUS_DATA_SUCCESS,
  SALES_ORDER_STATUS_DATA_FAILURE,
  SALES_ORDER_STATUS_CREATE,
  SALES_ORDER_STATUS_CREATE_SUCCESS,
  SALES_ORDER_STATUS_CREATE_FAILURE,
  SALES_ORDER_STATUS_UPDATE,
  SALES_ORDER_STATUS_UPDATE_SUCCESS,
  SALES_ORDER_STATUS_UPDATE_FAILURE,
  SALES_ORDER_STATUS_DELETE,
  SALES_ORDER_STATUS_DELETE_SUCCESS,
  SALES_ORDER_STATUS_DELETE_FAILURE,
  SALES_ORDER_ACTIVITY_LOG_SEARCH,
  SALES_ORDER_ACTIVITY_LOG_SEARCH_SUCCESS,
  SALES_ORDER_ACTIVITY_LOG_SEARCH_FAILURE,
  SALES_ORDER_CONVERT_TO_INVOICE,
  SALES_ORDER_CONVERT_TO_INVOICE_SUCCESS,
  SALES_ORDER_CONVERT_TO_INVOICE_FAILURE,
  PRODUCT_STOCK_RESERVED_SEARCH,
  PRODUCT_STOCK_RESERVED_SEARCH_SUCCESS,
  PRODUCT_STOCK_RESERVED_SEARCH_FAILURE,
  PRODUCT_STOCK_RESERVED_LIST,
  PRODUCT_STOCK_RESERVED_LIST_SUCCESS,
  PRODUCT_STOCK_RESERVED_LIST_FAILURE,
} from "./actionType";

//SALES_ORDER_LIST
export const salesOrderList = (payload) => ({
  type: SALES_ORDER_LIST,
  payload,
});
export const salesOrderListSuccess = (payload) => ({
  type: SALES_ORDER_LIST_SUCCESS,
  payload,
});
export const salesOrderListFailure = (payload) => ({
  type: SALES_ORDER_LIST_FAILURE,
  payload,
});

//SALES_ORDER_DATA
export const salesOrderData = (payload) => ({
  type: SALES_ORDER_DATA,
  payload,
});
export const salesOrderDataSuccess = (payload) => ({
  type: SALES_ORDER_DATA_SUCCESS,
  payload,
});
export const salesOrderDataFailure = (payload) => ({
  type: SALES_ORDER_DATA_FAILURE,
  payload,
});

//SALES_ORDER_SEARCH
export const salesOrderSearch = (payload) => ({
  type: SALES_ORDER_SEARCH,
  payload,
});
export const salesOrderSearchSuccess = (payload) => ({
  type: SALES_ORDER_SEARCH_SUCCESS,
  payload,
});
export const salesOrderSearchFailure = (payload) => ({
  type: SALES_ORDER_SEARCH_FAILURE,
  payload,
});

//SALES_ORDER_CREATE
export const salesOrderCreate = (payload) => ({
  type: SALES_ORDER_CREATE,
  payload,
});
export const salesOrderCreateSuccess = (payload) => ({
  type: SALES_ORDER_CREATE_SUCCESS,
  payload,
});
export const salesOrderCreateFailure = (payload) => ({
  type: SALES_ORDER_CREATE_FAILURE,
  payload,
});

//SALES_ORDER_UPDATE
export const salesOrderUpdate = (payload) => ({
  type: SALES_ORDER_UPDATE,
  payload,
});
export const salesOrderUpdateSuccess = (payload) => ({
  type: SALES_ORDER_UPDATE_SUCCESS,
  payload,
});
export const salesOrderUpdateFailure = (payload) => ({
  type: SALES_ORDER_UPDATE_FAILURE,
  payload,
});

//SALES_ORDER_VOID
export const salesOrderVoid = (payload) => ({
  type: SALES_ORDER_VOID,
  payload,
});
export const salesOrderVoidSuccess = (payload) => ({
  type: SALES_ORDER_VOID_SUCCESS,
  payload,
});
export const salesOrderVoidFailure = (payload) => ({
  type: SALES_ORDER_VOID_FAILURE,
  payload,
});

//SALES_ORDER_PDF
export const salesOrderPdf = (payload) => ({
  type: SALES_ORDER_PDF,
  payload,
});
export const salesOrderPdfSuccess = (payload) => ({
  type: SALES_ORDER_PDF_SUCCESS,
  payload,
});
export const salesOrderPdfFailure = (payload) => ({
  type: SALES_ORDER_PDF_FAILURE,
  payload,
});

//SALES_ORDER_EMAIL_AUTOMATED
export const salesOrderEmailAutomated = (payload) => ({
  type: SALES_ORDER_EMAIL_AUTOMATED,
  payload,
});
export const salesOrderEmailAutomatedSuccess = (payload) => ({
  type: SALES_ORDER_EMAIL_AUTOMATED_SUCCESS,
  payload,
});
export const salesOrderEmailAutomatedFailure = (payload) => ({
  type: SALES_ORDER_EMAIL_AUTOMATED_FAILURE,
  payload,
});

//SALES_ORDER_EMAIL_RESEND_AUTOMATED
export const salesOrderEmailResendAutomated = (payload) => ({
  type: SALES_ORDER_EMAIL_RESEND_AUTOMATED,
  payload,
});
export const salesOrderEmailResendAutomatedSuccess = (payload) => ({
  type: SALES_ORDER_EMAIL_RESEND_AUTOMATED_SUCCESS,
  payload,
});
export const salesOrderEmailResendAutomatedFailure = (payload) => ({
  type: SALES_ORDER_EMAIL_RESEND_AUTOMATED_FAILURE,
  payload,
});

//SALES_ORDER_DAILY_BALANCE
export const salesOrderDailyBalance = (payload) => ({
  type: SALES_ORDER_DAILY_BALANCE,
  payload,
});
export const salesOrderDailyBalanceSuccess = (payload) => ({
  type: SALES_ORDER_DAILY_BALANCE_SUCCESS,
  payload,
});
export const salesOrderDailyBalanceFailure = (payload) => ({
  type: SALES_ORDER_DAILY_BALANCE_FAILURE,
  payload,
});

//SALES_ORDER_ITEM_SEARCH
export const salesOrderItemSearch = (payload) => ({
  type: SALES_ORDER_ITEM_SEARCH,
  payload,
});

export const salesOrderItemSearchSuccess = (payload) => ({
  type: SALES_ORDER_ITEM_SEARCH_SUCCESS,
  payload,
});

export const salesOrderItemSearchFailure = (payload) => ({
  type: SALES_ORDER_ITEM_SEARCH_FAILURE,
  payload,
});

//SALES_ORDER_ITEM_LIST
export const salesOrderItemList = (payload) => ({
  type: SALES_ORDER_ITEM_LIST,
  payload,
});

export const salesOrderItemListSuccess = (payload) => ({
  type: SALES_ORDER_ITEM_LIST_SUCCESS,
  payload,
});

export const salesOrderItemListFailure = (payload) => ({
  type: SALES_ORDER_ITEM_LIST_FAILURE,
  payload,
});

//SALES_ORDER_STATUS_LIST
export const salesOrderStatusList = (payload) => ({
  type: SALES_ORDER_STATUS_LIST,
  payload,
});

export const salesOrderStatusListSuccess = (payload) => ({
  type: SALES_ORDER_STATUS_LIST_SUCCESS,
  payload,
});

export const salesOrderStatusListFailure = (payload) => ({
  type: SALES_ORDER_STATUS_LIST_FAILURE,
  payload,
});

//SALES_ORDER_STATUS_DATA
export const salesOrderStatusData = (payload) => ({
  type: SALES_ORDER_STATUS_DATA,
  payload,
});

export const salesOrderStatusDataSuccess = (payload) => ({
  type: SALES_ORDER_STATUS_DATA_SUCCESS,
  payload,
});

export const salesOrderStatusDataFailure = (payload) => ({
  type: SALES_ORDER_STATUS_DATA_FAILURE,
  payload,
});

//SALES_ORDER_STATUS_CREATE
export const salesOrderStatusCreate = (payload) => ({
  type: SALES_ORDER_STATUS_CREATE,
  payload,
});

export const salesOrderStatusCreateSuccess = (payload) => ({
  type: SALES_ORDER_STATUS_CREATE_SUCCESS,
  payload,
});

export const salesOrderStatusCreateFailure = (payload) => ({
  type: SALES_ORDER_STATUS_CREATE_FAILURE,
  payload,
});

//SALES_ORDER_STATUS_UPDATE
export const salesOrderStatusUpdate = (payload) => ({
  type: SALES_ORDER_STATUS_UPDATE,
  payload,
});

export const salesOrderStatusUpdateSuccess = (payload) => ({
  type: SALES_ORDER_STATUS_UPDATE_SUCCESS,
  payload,
});

export const salesOrderStatusUpdateFailure = (payload) => ({
  type: SALES_ORDER_STATUS_UPDATE_FAILURE,
  payload,
});

//SALES_ORDER_STATUS_DELETE
export const salesOrderStatusDelete = (payload) => ({
  type: SALES_ORDER_STATUS_DELETE,
  payload,
});

export const salesOrderStatusDeleteSuccess = (payload) => ({
  type: SALES_ORDER_STATUS_DELETE_SUCCESS,
  payload,
});

export const salesOrderStatusDeleteFailure = (payload) => ({
  type: SALES_ORDER_STATUS_DELETE_FAILURE,
  payload,
});

//SALES_ORDER_ACTIVITY_LOG_SEARCH
export const salesOrderActivityLogSearch = (payload) => ({
  type: SALES_ORDER_ACTIVITY_LOG_SEARCH,
  payload,
});

export const salesOrderActivityLogSearchSuccess = (payload) => ({
  type: SALES_ORDER_ACTIVITY_LOG_SEARCH_SUCCESS,
  payload,
});

export const salesOrderActivityLogSearchFailure = (payload) => ({
  type: SALES_ORDER_ACTIVITY_LOG_SEARCH_FAILURE,
  payload,
});

//SALES_ORDER_CONVERT_TO_INVOICE
export const salesOrderConvertToInvoice = (payload) => ({
  type: SALES_ORDER_CONVERT_TO_INVOICE,
  payload,
});

export const salesOrderConvertToInvoiceSuccess = (payload) => ({
  type: SALES_ORDER_CONVERT_TO_INVOICE_SUCCESS,
  payload,
});

export const salesOrderConvertToInvoiceFailure = (payload) => ({
  type: SALES_ORDER_CONVERT_TO_INVOICE_FAILURE,
  payload,
});

//PRODUCT_STOCK_RESERVED_SEARCH
export const productStockReservedSearch = (payload) => ({
  type: PRODUCT_STOCK_RESERVED_SEARCH,
  payload,
});

export const productStockReservedSearchSuccess = (payload) => ({
  type: PRODUCT_STOCK_RESERVED_SEARCH_SUCCESS,
  payload,
});

export const productStockReservedSearchFailure = (payload) => ({
  type: PRODUCT_STOCK_RESERVED_SEARCH_FAILURE,
  payload,
});

//PRODUCT_STOCK_RESERVED_LIST
export const productStockReservedList = (payload) => ({
  type: PRODUCT_STOCK_RESERVED_LIST,
  payload,
});

export const productStockReservedListSuccess = (payload) => ({
  type: PRODUCT_STOCK_RESERVED_LIST_SUCCESS,
  payload,
});

export const productStockReservedListFailure = (payload) => ({
  type: PRODUCT_STOCK_RESERVED_LIST_FAILURE,
  payload,
});
